import { axiosV2 } from "./axios";

// ----------------------------------------------------------------------
// LOCALIZATION HELPER
// ----------------------------------------------------------------------

export function getLocalizedText(value, fallback = "-") {
  if (!value) return fallback;

  if (typeof value === "string") {
    return value || fallback;
  }

  return value.en || value.other_language || fallback;
}

// ----------------------------------------------------------------------
// ID HELPER
// ----------------------------------------------------------------------

export function getResolvedId(value) {
  if (!value) return null;

  if (typeof value === "string") {
    return value;
  }

  return value.id || value._id || null;
}

// ----------------------------------------------------------------------
// RESPONSE HELPERS
// ----------------------------------------------------------------------

export const getResults = (response) => {
  const data = response?.data;

  if (Array.isArray(data)) return data;

  if (Array.isArray(data?.results)) {
    return data.results;
  }

  if (Array.isArray(data?.data?.results)) {
    return data.data.results;
  }

  if (Array.isArray(data?.data)) {
    return data.data;
  }

  return [];
};

export const getResource = (response, key) => {
  const data = response?.data;

  return data?.result || data?.[key] || data?.data || data;
};

// ----------------------------------------------------------------------
// API METHODS
// ----------------------------------------------------------------------

export const apiGet = (endpoint, params = {}) => {
  return axiosV2.get(endpoint, { params });
};

export const apiPost = (endpoint, body = {}, params = {}) => {
  return axiosV2.post(endpoint, body, { params });
};

export const apiPut = (endpoint, body = {}, params = {}) => {
  return axiosV2.put(endpoint, body, { params });
};

export const apiPatch = (endpoint, body = {}, params = {}) => {
  return axiosV2.patch(endpoint, body, { params });
};

export const apiDelete = (endpoint, params = {}) => {
  return axiosV2.delete(endpoint, { params });
};

// ----------------------------------------------------------------------
// COMMON REDUX REQUEST HANDLER
// ----------------------------------------------------------------------

export const handleApiRequest = async ({
  dispatch,
  startLoading,
  hasError,
  request,
}) => {
  dispatch(startLoading());

  try {
    return await request();
  } catch (error) {
    dispatch(hasError(error));

    return {
      status: 500,
      error,
    };
  }
};